<template>
  <div>
    <div class="w1100">
     	<div class="floatL leftnr marginT10">
         
        <div class="is-title">{{channel.nameChn}}</div>
            <div class="is-menu" v-if="moduleList">
              <template v-for="item in moduleList">
                <div :key="'module-item'+item.nameChn">
                  <h1 v-if="item.id == 6150">
                    <a :href="'/qsxf-web/module/list?code='+item.id" :title="item.nameChn" target="_self">
                    {{item.nameChn}}
                    </a>
                  </h1>
                  <h1 v-else-if="item.id == 6154 || item.id == 6150 || item.id == 6204">
                    <a :href="'/qsxf-web/module/index?code='+item.id" :title="item.nameChn" target="_self">
                    {{item.nameChn}}
                    </a>
                  </h1> 
                  <h1 v-else>
                    <a :href="'/qsxf-web/module/list?code='+item.id" :title="item.nameChn" target="_self">
                    {{item.nameChn}}
                    </a>
                  </h1> 
                </div>  
              </template>
        </div>
            <!--通知公告-->
			<div class="is-title marginT10">通知公告</div>
                <div class="ph_List f14">
                    <ul>
                        <li v-for="(item ,i) in this.noticeList" :key="'notice'+item.id+i">
                            <a class="title" :title="item.title" :href="'/qsxf-web/detail?id='+item.id" target="_blank" style="">{{item.title}}</a>
                        </li>
                    </ul>
                </div>      
        </div>
        <div class="floatR marginT10" style="width:777px;">
            <div :class="itemList[0].className" :style="itemList[0].style" v-for="(itemList,i) in this.list" :key="'moduleIndex'+i">
            	<div class="list_frtit">
                	<div class="floatL f14">{{itemList[0].channelName}}</div>
                    <div class="floatR"><a @click="openModule(itemList[0].channelId)" href="javascript:;" title="" >更多&gt;&gt;</a></div>
                    <div class="clear"></div>
                </div>
                <div class="list_frList f14">
                    <ul>
                        <li v-for="item in itemList" :key="'moduleIndexItem'+item.contentId">
                            <div class="floatL w257 ellipsis">
                                <a :href="'/qsxf-web/detail?id='+item.contentId" :title="item.title" target="_blank">
                                {{item.title}}
                                </a>
                            </div>
                            <div class="floatR">[{{item.createTime.substring(5,10)}}]</div>
                            <div class="clear"></div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="clear"></div>
    </div>
  </div>
</template>


<script>

import request from '@/common/request'
import  '../assets/css/css.css'

export default {
  name: 'ModuleIndex',
  data () {
    return {
        code:null,
        noticeList:[],
        list:[],
        moduleList:[],
        channel:{}
    }
  },
  watch: {
    $route(to, from){
        this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
      openModule:function(code){
          if(6154 == code){
            window.open('/qsxf-web/module/index?code='+code);
          }else{
            window.open('/qsxf-web/module/list?code='+code);
          }
      },
      init:function(){
        this.code = this.$route.query.code;
        //获取通知公告
        this.getContentByChannel(6178,1,10).then(data=>{
        if(data.errorCode == 0 && data.result && data.result.list){
            this.noticeList = data.result.list;
        }
        });
        this.getModuleContent().then(data=>{
        if(data.errorCode == 0 && data.result){
            this.list = data.result;
            //增加样式
            for(var i = 0;i< this.list.length;i++){
                for(var j in this.list[i]){
                    this.list[i][j].style = "width:376px;";
                    if((i+1)%2 == 0){
                        if(i == 1){
                            this.list[i][j].className = "floatL marginL20";
                        }else{
                            this.list[i][j].className = "floatL marginL20 marginT10";
                        }
                    }else{
                        if(i == 0){
                            this.list[i][j].className = "floatL";
                        }else{
                            this.list[i][j].className = "floatL marginT10";
                        }
                    }
                    //如果最后一个元素是奇数
                    if(i == this.list.length-1 && (i+1)%2 == 1){
                        this.list[i][j].style = "width:772px;";
                    }
                }
            }
        }
        });

        //获取模块
        this.getModuleList(this.code).then(data=>{
          if(data.errorCode == 0 && data.result && data.result.list){
            this.moduleList = data.result.list;
            this.channel = data.result.channel;
          }
        });
      },
      getModuleContent:function(){
        return request({
          url: '/index/getModuleContent',
          method: 'get',
          params: { 
            "channelId":this.code
          }
        })
      },
      getContentByChannel:function(code,pageIndex,pageSize){
        return request({
          url: '/index/getContentByChannel',
          method: 'get',
          params: { 
            "pageIndex":pageIndex,
            "pageSize":pageSize,
            "id":code
          }
        })
      },
      getModuleList:function(code){
        return request({
          url: '/index/getModuleList',
          method: 'get',
          params: {
            "id":code
          }
        })
      }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ModuleIndex.vue